module.exports = __webpack_public_path__ + "static/panorama-562573d2274bc9a0e2e29bb3b9ddd3c5.png";